import { publicSupabase } from "@/lib/supabase/publicClient";
import { buildStructuredIdentity } from "@/features/identity/buildStructuredIdentity";
import { getCanonicalProfileUrl } from "@/lib/canonicalUrl";

const first = (d) => (Array.isArray(d) ? d[0] : d) || null;
const pick = (row, ...keys) => keys.map((k) => row?.[k]).find((v) => v != null && v !== "") ?? null;

// Public data comes only from the published-profile RPCs (never direct table reads).
export async function fetchPublicProfile(slug) {
  const [p, l, c] = await Promise.all(
    ["get_public_profile", "get_public_profile_links", "get_public_contact"].map((fn) => publicSupabase.rpc(fn, { p_slug: slug })),
  );
  if (p.error) throw p.error;
  const profile = first(p.data);
  if (!profile) return null;
  const contact = first(c.data) || {};
  const links = (l.data || []).map((x, i) => ({ platform: x.platform, url: x.url, is_visible: x.is_visible ?? true, display_order: x.display_order ?? i }));
  const merged = {
    full_name: pick(profile, "full_name", "fullName", "name"),
    professional_title: pick(profile, "professional_title", "title"),
    company_name: pick(profile, "company_name", "company"),
    profile_photo_url: pick(profile, "profile_photo_url", "photo_url"),
    company_logo_url: pick(profile, "company_logo_url", "logo_url"),
    bio: pick(profile, "bio"),
    email: pick(contact, "email") ?? pick(profile, "email"),
    phone: pick(contact, "phone") ?? pick(profile, "phone"),
    website: pick(contact, "website") ?? pick(profile, "website"),
  };
  const config = profile.profile_design_config || profile.design_config || {};
  return {
    identity: buildStructuredIdentity(merged, links, { canonicalUrl: getCanonicalProfileUrl(profile.profile_slug || profile.slug || slug) }),
    themeColor: config.themeColor ?? profile.theme_color ?? null,
  };
}

export function recordPublicEvent(slug, eventType, metadata = {}) {
  publicSupabase
    .rpc("record_public_event", { p_slug: slug, p_event_type: eventType, p_metadata: metadata })
    .then(() => {}, () => {});
}
